var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 11.2158 11.2578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 11.2578,
    opacity: 0,
    width: 11.2158,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24121 11.1098L8.68652 8.60985C8.76953 8.46336 8.72559 8.28758 8.5791 8.21434C8.4375 8.13621 8.2666 8.17039 8.18359 8.32176L6.74805 10.812C6.66016 10.9585 6.7041 11.1294 6.8457 11.2173C6.98242 11.3003 7.16309 11.2514 7.24121 11.1098Z",
    fill: "white",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 11.105L6.74316 8.61961C6.83105 8.46336 6.78711 8.29735 6.64062 8.21434C6.48926 8.12645 6.32324 8.17039 6.23535 8.32664L4.7998 10.8218C4.72168 10.9585 4.75586 11.1294 4.90723 11.2173C5.05371 11.3003 5.22949 11.2514 5.3125 11.105Z",
    fill: "white",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36914 11.105L4.7998 8.61961C4.8877 8.46336 4.84375 8.29735 4.69727 8.21434C4.5459 8.12645 4.37988 8.17039 4.29199 8.32664L2.85645 10.8218C2.77832 10.9585 2.8125 11.1294 2.96387 11.2173C3.11035 11.3003 3.28613 11.2514 3.36914 11.105Z",
    fill: "white",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4209 11.105L2.85645 8.61961C2.94434 8.46336 2.89551 8.29735 2.74902 8.21434C2.60254 8.12645 2.43652 8.17039 2.34863 8.32664L0.908203 10.8218C0.830078 10.9585 0.869141 11.1294 1.01562 11.2173C1.16211 11.3003 1.33789 11.2514 1.4209 11.105Z",
    fill: "white",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.29492 7.43309L8.35449 7.43309C9.95605 7.43309 11.1475 6.21727 11.1475 4.71336C11.1475 3.15575 9.87793 2.01805 8.22266 2.01805C7.6123 0.811995 6.47949 0.0356283 5.06836 0.0356283C3.23242 0.0356283 1.71875 1.47606 1.55762 3.28758C0.673828 3.54637 0 4.31297 0 5.34325C0 6.50047 0.839844 7.43309 2.29492 7.43309ZM2.28516 6.65184C1.28418 6.65184 0.78125 6.09032 0.78125 5.36766C0.78125 4.78172 1.12305 4.25438 1.95312 4.03465C2.22168 3.96141 2.31934 3.83446 2.34375 3.56102C2.45605 1.96434 3.65234 0.816878 5.06836 0.816878C6.16699 0.816878 7.03125 1.42235 7.55859 2.50145C7.6709 2.74071 7.81738 2.82371 8.10547 2.82371C9.55078 2.82371 10.3662 3.69285 10.3662 4.73289C10.3662 5.79735 9.5166 6.65184 8.40332 6.65184Z",
    fill: "white",
    fillOpacity: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.cdf3af74e570e3c310d1ccbe765477be.svg";
export { ForwardRef as ReactComponent };